import { from, of } from "rxjs";
import { IdResource } from "../../constants/IdResource";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { IdMissingResourceTypes } from "../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../ongoing-purchase/actionOngoingPurchase";
export var pathNotEnoughGold = function (action) {
    var playerGold = action.playerGold, requiredGold = action.requiredGold, onNotEnoughGold = action.onNotEnoughGold;
    var missingGold = requiredGold.subtract(playerGold);
    if (onNotEnoughGold !== undefined) {
        return of(onNotEnoughGold);
    }
    return from([
        actionOngoingPurchaseStandardSelect([
            {
                missingResources: [{ amount: missingGold, typeId: IdResource.Gold }],
                missingType: IdMissingResourceTypes.Gold,
            },
        ]),
        actionModalOpen(IdModal.NotEnoughResource),
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/buy-with-gold/pathNotEnoughGold.ts
// module id = 1790
// module chunks = 3